
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment, useState } from "react";
import Select from "react-select";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Accordion from '../../accordion'


// ../../../../images/candidate/upload.png
//  download fill

import Upload from "../../../../images/candidate/download.svg";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Form,
  Input,
} from "reactstrap";

import pdf from "../../images/document.svg";
import { initailState } from "../utils/profileReducer";
import { LocationSearchInput, NextButton, TextInput } from "./UserInputs";
import request from "../../../../api/api";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'
import { useProfilecontext } from "../Editprofileprovider";
import { createFormData , scroll_to_top, } from "../../../common/utils";







const addfileToServer = async (file = {}) =>{
    try {
    const res = await request({ url: "/candidate/form/addFilestoLocalDB", method: "POST", data:file,})
        return res.file_path ? res.file_path :''
    } catch (error) {
        return error;
    }
}


const accordion_id = {
    reference_1:0,
    reference_2:1,
    reference_3:2
}


export default function ReferenceTab ({ isactivetab = ()=>{} , activeTab = {},active_accordionId}) {
    

    const [ state , dispatch ] = useProfilecontext();
        // { } = state;

    const [active_accordion , setActiveAccordion ] = useState(accordion_id[active_accordionId] || accordion_id['reference_1'])

    const toggleAccordion = (id = '',accordin_menu = "personal_details") => {
        setActiveAccordion((prev)=>(accordion_id[id]) || prev)

    }

        
    const toggleTab = (tab = '', tabId = '') => {
        dispatch({ type: "TOGGLE_TAB", payload: { tab, tabId } })
        scroll_to_top()
    }

    const handleSetToast = ({id = '' , message = '' , type = ''})=>{
        dispatch({type:"SET_TOAST" , payload:{ id, message , type}})
    }
    

    
    return (
        
        <div className="emp_edu reference-page">
        <div className="emp_heading">
            <h6 className="mt-0 ">References</h6>
            <p>Please supply us with two professional referees. One must be from your present or most recent employer and must be a senior grade to yourself and you must have worked for that person for a period of not less than three months duration. It is essential that you have had professional
			dealings with your references for at least 3 years. Please provide a minimum of 2 professional references, or 1 character reference and 1 professional reference.</p>
            <p style={{color:"#ff0000"}}></p>
        </div>
        <hr style={{width:"100%"}}/>
        <Accordion style={{width:"100%"}} open={active_accordion} toggleAccordion={setActiveAccordion} >

            <Accordion.Item>
                <Accordion.Header>
                    Reference 1
                </Accordion.Header>
                <Accordion.Body>
                    <ReferenceOne {...state}  toggleAccordion={toggleAccordion} toggleTab={toggleTab} handleSetToast={handleSetToast} />
                </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item>
                <Accordion.Header>
                    Reference 2
                </Accordion.Header>
                <Accordion.Body>
                    <ReferenceTwo {...state}  toggleAccordion={toggleAccordion} toggleTab={toggleTab} handleSetToast={handleSetToast} />  
                </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item>
                <Accordion.Header>
                    Reference 3
                </Accordion.Header>
                <Accordion.Body>
                    <ReferenceThird {...state}  toggleAccordion={toggleAccordion} toggleTab={toggleTab} handleSetToast={handleSetToast}  />
                </Accordion.Body>
            </Accordion.Item>

        </Accordion>
        
        {/* <hr style={{width:"100%"}}/> */}
            
        <div className="position-relative col-12 col-md-12">
            <div className="mt-0 text-center three_button" id="s-c-buttons">
                <Button type="button" onClick={()=>toggleTab("menu", '2')}><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Previous</Button>
                {/* <Button className="btn-save" >Save</Button>
                <Button type="button" onClick={()=>toggleTab("menu", '4')} >Continue</Button> */}
            </div>
        </div>

    </div>
    )
}



// /agency/employees/apply-online-form/reference/update to update ;

const refference1_Schema = yup.object({
    "firstref_address": yup.object({
        "firstrefstreetAddress": yup.string(),
        "firstrefcity": yup.string(),
        "firstrefstate": yup.string(),
        "firstrefzip": yup.string()
    }),
    "firstrefemail":yup.string().email("Incorrect Email").required("Incorrect Email"),
    "firstrefconfirmemail":yup.string().email("Incorrect Email").required("Incorrect Email")
                              .oneOf([yup.ref("firstrefemail"), null], "Email don't match"),
    "firstreffirstname": yup.string().required("Incorrect Data"),
    "firstreflastname": yup.string().required("Incorrect Data"),
    "firstrefphone": yup.object({
        "number": yup.string(),
        "code": yup.string().default("42"),
        "dialcountry": yup.string().default("gb")
    }),
    "firstrefrelationship": yup.string()
})


const ReferenceOne  = (props = initailState) =>{

    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register , formState , handleSubmit , setValue , watch} = useForm({
        values:{
        firstref_address:{
            firstrefstreetAddress: props.firstref_address.firstrefstreetAddress ,
            firstrefcity: props.firstref_address.firstrefcity ,
            firstrefstate: props.firstref_address.firstrefstate ,
            firstrefzip: props.firstref_address.firstrefzip ,
        },

        "firstrefconfirmemail": props.firstrefconfirmemail ||  "",
        "firstrefemail": props.firstrefemail ||  "",
        "firstreffirstname": props.firstreffirstname ||  "",
        "firstreflastname": props.firstreflastname ||  "",
        "firstrefphone":{
            "number": props.firstrefphone.number ||  "",
            "code": props.firstrefphone.code ||  "44",
            "dialcountry": props.firstrefphone.dialcountry ||  "gb",
        },
        "firstrefrelationship": props.firstrefrelationship ||  "",
        },
        resolver:yupResolver(refference1_Schema)
    }),
    { errors } = formState;
    const streetAddress = register("firstref_address.firstrefstreetAddress")


    const handleOnAddressSelect = (data = {} , res)=>{
        const {  addressline1 = "" ,addressline2 = "" ,city = "" ,state = "" ,country = "" ,zip  = "" } = data;
         setValue("firstref_address.firstrefstreetAddress" , addressline1 , {shouldDirty:true});
         setValue("firstref_address.firstrefzip" , zip , {shouldDirty:true});
         setValue("firstref_address.firstrefcity" , city , {shouldDirty:true});
         setValue("firstref_address.firstrefstate" , state , {shouldDirty:true});
        //  setValue("kinaddressline2" , addressline2 , {shouldDirty:true});
        //  setValue("kincountry" , country , {shouldDirty:true});


    }
    

    const onFormSubmit = (data = {}) =>{

        // if(!formState.isDirty){
        //     handleSetToast && handleSetToast({id:"reference_1" , message:"Saved !" , type:'success'})
        //     return toggleAccordion("reference_2")
        // }

        let body = {...data };
            body = body.firstref_address ? {...body ,...body.firstref_address } : body;
            body = body.firstrefphone ? {...body ,...body.firstrefphone} : body;
            body.setctionId = 'reference_1';
            delete body.firstref_address;
            delete body.firstrefphone;
        const reference1 = createFormData(body);
        if(updateForm){
            updateForm(reference1).then((res)=>{
                handleSetToast && handleSetToast({id:"reference_1" , message:"Saved !" , type:'success'})
                toggleAccordion("reference_2")
                
            })
        }
    };


    return <Form onSubmit={handleSubmit(onFormSubmit)} >

        <TextInput label="Relationship" placeholder="Relationship" {...register("firstrefrelationship")} error={errors.firstrefrelationship && errors.firstrefrelationship.message} />

        <TextInput label="First Name" placeholder="First Name" required {...register("firstreffirstname")} error={errors.firstreffirstname && errors.firstreffirstname.message}  />

        <TextInput label="Last Name" placeholder="Last Name" required {...register("firstreflastname")} error={errors.firstreflastname && errors.firstreflastname.message} />

        <TextInput label="Mobile No" placeholder="Mobile No" {...register("firstrefphone.number")}  />

        <TextInput label="Email Address" required placeholder="Email Address" {...register("firstrefemail")} error={errors.firstrefemail && errors.firstrefemail.message} />
        
        <TextInput label="Confirm Email Address" required placeholder="Confirm Email Address" {...register("firstrefconfirmemail")} error={errors.firstrefconfirmemail && errors.firstrefconfirmemail.message} />

        <h6 className="mt-2 p-3 w-100">Address</h6>

        <LocationSearchInput onSelect={handleOnAddressSelect} label="House/Flat/Building" ref={streetAddress.ref} handleOnchange={(e)=>setValue("firstref_address.firstrefstreetAddress" ,e , {shouldDirty:true})} value={watch("firstref_address.firstrefstreetAddress")} />


        {/* <TextInput label="Street Address" placeholder="Street Address" {...register("firstref_address.firstrefstreetAddress")} error={errors.firstref_address && errors.firstref_address.firstrefstreetAddress.message} /> */}

        <TextInput label="City" placeholder="City" {...register("firstref_address.firstrefcity")} error={errors.firstref_address && errors.firstref_address.firstrefcity.message} />

        <TextInput label="State / Region" placeholder="State / Region" {...register("firstref_address.firstrefstate")} error={errors.firstref_address && errors.firstref_address.firstrefstate.message} />
        
        <TextInput label="ZIP / Postal Code" placeholder="ZIP / Postal Code" {...register("firstref_address.firstrefzip")} error={errors.firstref_address && errors.firstref_address.firstrefzip.message} />

        <NextButton />
    </Form>
}










const refference2_Schema = yup.object({
    "secondref_address": yup.object({
        "secondrefstreetAddress": yup.string(),
        "secondrefcity": yup.string(),
        "secondrefstate": yup.string(),
        "secondrefzip": yup.string()
    }),
    "secondrefemail":yup.string().email("Incorrect Email").required("Incorrect Email"),
    "secondrefconfirmemail":yup.string().email("Incorrect Email").required("Incorrect Email")
                              .oneOf([yup.ref("secondrefemail"), null], "Email don't match"),
    "secondreffirstname": yup.string().required("Incorrect Data"),
    "secondreflastname": yup.string().required("Incorrect Data"),
    "secondrefphone": yup.object({
        "number": yup.string(),
        "code": yup.string().default("42"),
        "dialcountry": yup.string().default("gb")
    }),
    "secondrefrelationship": yup.string()
})


const ReferenceTwo  = (props = initailState) =>{

    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register , reset , formState , handleSubmit , setValue , watch} = useForm({
        values:{
        secondref_address:{
            secondrefstreetAddress: (props.secondref_address && props.secondref_address.secondrefstreetAddress) ||  ""  ,
            secondrefcity: (props.secondref_address && props.secondref_address.secondrefcity) ||  ""  ,
            secondrefstate: (props.secondref_address && props.secondref_address.secondrefstate) ||  ""  ,
            secondrefzip: (props.secondref_address && props.secondref_address.secondrefzip) ||  ""  ,
        },

        "secondrefconfirmemail": props.secondrefconfirmemail ||  "",
        "secondrefemail": props.secondrefemail ||  "",
        "secondreffirstname": props.secondreffirstname ||  "",
        "secondreflastname": props.secondreflastname ||  "",
        "secondrefphone":{
            "number":  (props.secondrefphone && props.secondrefphone.number) ||  "",
            "code":  (props.secondrefphone && props.secondrefphone.code) ||  "44",
            "dialcountry":  (props.secondrefphone && props.secondrefphone.dialcountry) ||  "gb",
        },
        "secondrefrelationship": props.secondrefrelationship ||  "",
        },
        resolver:yupResolver(refference2_Schema)
    }),
    { errors } = formState;

    const streetAddress = register("secondref_address.secondrefstreetAddress");



    const handleOnAddressSelect = (data = {} , res)=>{
        const {  addressline1 = "" ,addressline2 = "" ,city = "" ,state = "" ,country = "" ,zip  = "" } = data;
         setValue("secondref_address.secondrefstreetAddress" , addressline1 , {shouldDirty:true});
         setValue("secondref_address.secondrefzip" , zip , {shouldDirty:true});
         setValue("secondref_address.secondrefcity" , city , {shouldDirty:true});
         setValue("secondref_address.secondrefstate" , state , {shouldDirty:true});
        //  setValue("kinaddressline2" , addressline2 , {shouldDirty:true});
        //  setValue("kincountry" , country , {shouldDirty:true});
    }


    const onFormSubmit = (data = {}) =>{
        // if(!formState.isDirty){
        //     handleSetToast && handleSetToast({id:"reference_2" , message:"Saved !" , type:'success'})
        //     return toggleAccordion("reference_3")
        // }
        let body = {...data };
            body = body.secondref_address ? {...body ,...body.secondref_address } : body;
            body = body.secondrefphone ? {...body ,...body.secondrefphone} : body;
            body.setctionId = 'reference_2';
            delete body.secondref_address;
            delete body.secondrefphone;
        const reference2 = createFormData(body);
        if(updateForm){
            updateForm(reference2).then((res)=>{
                reset({},{ keepValues:true})
                handleSetToast && handleSetToast({id:"reference_2" , message:"Saved !" , type:'success'})
                toggleAccordion("reference_3")
                
            })
        }
    };

    return <Form onSubmit={handleSubmit(onFormSubmit)} >

        <TextInput label="Relationship" placeholder="Relationship" {...register("secondrefrelationship")} error={errors.secondrefrelationship && errors.secondrefrelationship.message} />

        <TextInput label="First Name" required placeholder="First Name" {...register("secondreffirstname")} error={errors.secondreffirstname && errors.secondreffirstname.message}  />

        <TextInput label="Last Name" required placeholder="Last Name" {...register("secondreflastname")} error={errors.secondreflastname && errors.secondreflastname.message} />

        <TextInput label="Mobile No" placeholder="Mobile No" {...register("secondrefphone.number")}  />

        <TextInput label="Email Address" required placeholder="Email Address" {...register("secondrefemail")} error={errors.secondrefemail && errors.secondrefemail.message} />
        
        <TextInput label="Confirm Email Address" required placeholder="Confirm Email Address" {...register("secondrefconfirmemail")} error={errors.secondrefconfirmemail && errors.secondrefconfirmemail.message} />

        <h6 className="mt-2 p-3 w-100">Address</h6>

        <LocationSearchInput onSelect={handleOnAddressSelect} label="House/Flat/Building" ref={streetAddress.ref} handleOnchange={(e)=>setValue("secondref_address.secondrefstreetAddress" ,e , {shouldDirty:true})} value={watch("secondref_address.secondrefstreetAddress")} />

        {/* <TextInput label="Street Address" placeholder="Street Address" {...register("secondref_address.secondrefstreetAddress")} error={errors.secondref_address && errors.secondref_address.secondrefstreetAddress.message} /> */}

        <TextInput label="City" placeholder="City" {...register("secondref_address.secondrefcity")} error={errors.secondref_address && errors.secondref_address.secondrefcity.message} />

        
        <TextInput label="State / Region" placeholder="State / Region" {...register("secondref_address.secondrefstate")} error={errors.secondref_address && errors.secondref_address.secondrefstate.message} />
        
        <TextInput label="ZIP / Postal Code" placeholder="ZIP / Postal Code" {...register("secondref_address.secondrefzip")} error={errors.secondref_address && errors.secondref_address.secondrefzip.message} />

        <NextButton />
    </Form>
}










// 

const refference3_Schema = yup.object({
    "thirdref_address": yup.object({
        "thirdrefstreetAddress": yup.string(),
        "thirdrefcity": yup.string(),
        "thirdrefstate": yup.string(),
        "thirdrefzip": yup.string()
    }),
    "thirdrefemail":yup.string().email("Incorrect Email").required("Incorrect Email"),
    "thirdrefconfirmemail":yup.string().email("Incorrect Email").required("Incorrect Email")
                              .oneOf([yup.ref("thirdrefemail"), null], "Email don't match"),
    "thirdreffirstname": yup.string().required("Incorrect Data"),
    "thirdreflastname": yup.string().required("Incorrect Data"),
    "thirdrefphone": yup.object({
        "number": yup.string(),
        "code": yup.string().default("42"),
        "dialcountry": yup.string().default("gb")
    }),
    "thirdrefrelationship": yup.string()
})


const ReferenceThird  = (props = initailState) =>{

    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register  , getValues , reset , formState , handleSubmit, setValue , watch} = useForm({
        values:{
        thirdref_address:{
            thirdrefstreetAddress: (props.thirdref_address && props.thirdref_address.thirdrefstreetAddress) || "" ,
            thirdrefcity: (props.thirdref_address && props.thirdref_address.thirdrefcity) || "" ,
            thirdrefstate: (props.thirdref_address && props.thirdref_address.thirdrefstate) || "" ,
            thirdrefzip: (props.thirdref_address && props.thirdref_address.thirdrefzip) || "" ,
        },

        "thirdrefconfirmemail": props.thirdrefconfirmemail ||  "",
        "thirdrefemail": props.thirdrefemail ||  "",
        "thirdreffirstname": props.thirdreffirstname ||  "",
        "thirdreflastname": props.thirdreflastname ||  "",
        "thirdrefphone":{
            "number": (props.thirdrefphone &&  props.thirdrefphone.number) ||  "",
            "code": (props.thirdrefphone &&  props.thirdrefphone.code) ||  "44",
            "dialcountry": (props.thirdrefphone &&  props.thirdrefphone.dialcountry) ||  "gb",
        },
        "thirdrefrelationship": props.thirdrefrelationship ||  "",
        },
        resolver:yupResolver(refference3_Schema)
    }),
    { errors } = formState;
    const streetAddress = register("thirdref_address.thirdrefstreetAddress")



    const handleOnAddressSelect = (data = {} , res)=>{
        const {  addressline1 = "" ,addressline2 = "" ,city = "" ,state = "" ,country = "" ,zip  = "" } = data;
         setValue("thirdref_address.thirdrefstreetAddress" , addressline1 , {shouldDirty:true});
         setValue("thirdref_address.thirdrefzip" , zip , {shouldDirty:true});
         setValue("thirdref_address.thirdrefcity" , city , {shouldDirty:true});
         setValue("thirdref_address.thirdrefstate" , state , {shouldDirty:true});
        //  setValue("kinaddressline2" , addressline2 , {shouldDirty:true});
        //  setValue("kincountry" , country , {shouldDirty:true});
    }


    const onFormSubmit = (data = {}) =>{
        let body = {...data };
            body = body.thirdref_address ? {...body ,...body.thirdref_address } : body;
            body = body.thirdrefphone ? {...body ,...body.thirdrefphone} : body;
            body.setctionId = 'reference_3';
            delete body.thirdref_address;
            delete body.thirdrefphone;
        const reference3 = createFormData(body);
        if(updateForm){
            updateForm(reference3).then((res)=>{
                reset({},{ keepValues:true})
                handleSetToast && handleSetToast({id:"reference_3" , message:"Saved !" , type:'success'})                
            })
        }
    };


    const handleOnContinue = async () =>{
        if(formState.isDirty){
            onFormSubmit(getValues())
        }
        toggleTab("menu" ,'4')
	}

    return <Form onSubmit={handleSubmit(onFormSubmit)} >

        <TextInput label="Relationship"  placeholder="Relationship" {...register("thirdrefrelationship")} error={errors.thirdrefrelationship && errors.thirdrefrelationship.message} />

        <TextInput label="First Name" required placeholder="First Name" {...register("thirdreffirstname")} error={errors.thirdreffirstname && errors.thirdreffirstname.message}  />

        <TextInput label="Last Name" required placeholder="Last Name" {...register("thirdreflastname")} error={errors.thirdreflastname && errors.thirdreflastname.message} />

        <TextInput label="Mobile No"  placeholder="Mobile No" {...register("thirdrefphone.number")}  />

        <TextInput label="Email Address" required placeholder="Email Address" {...register("thirdrefemail")} error={errors.thirdrefemail && errors.thirdrefemail.message} />
        
        <TextInput label="Confirm Email Address" placeholder="Confirm Email Address" {...register("thirdrefconfirmemail")} error={errors.thirdrefconfirmemail && errors.thirdrefconfirmemail.message} />

        <h6 className="mt-2 p-3 w-100">Address</h6>

        <LocationSearchInput onSelect={handleOnAddressSelect} label="House/Flat/Building" ref={streetAddress.ref} handleOnchange={(e)=>setValue("thirdref_address.thirdrefstreetAddress" ,e , {shouldDirty:true})} value={watch("thirdref_address.thirdrefstreetAddress")} />

        {/* <TextInput label="Street Address" placeholder="Street Address" {...register("thirdref_address.thirdrefstreetAddress")} error={errors.thirdref_address && errors.thirdref_address.thirdrefstreetAddress.message} /> */}

        <TextInput label="City" placeholder="City" {...register("thirdref_address.thirdrefcity")} error={errors.thirdref_address && errors.thirdref_address.thirdrefcity.message} />

        <TextInput label="State / Region" placeholder="State / Region" {...register("thirdref_address.thirdrefstate")} error={errors.thirdref_address && errors.thirdref_address.thirdrefstate.message} />
        
        <TextInput label="ZIP / Postal Code" placeholder="ZIP / Postal Code" {...register("thirdref_address.thirdrefzip")} error={errors.thirdref_address && errors.thirdref_address.thirdrefzip.message} />

        {/* <NextButton /> */}
        <div className="position-relative col-12 col-md-12">
            <div className="mt-0 text-center three_button" id="s-c-buttons">
                {/* <Button type="button" onClick={()=>toggleTab("menu", '2')}><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Previous</Button> */}

                <Button  className={`btn-save ${formState.isDirty ? "" : "cursor-no-drop"}`} disabled={!formState.isDirty} >Save</Button>
                <Button type="button" onClick={() => handleOnContinue()} >Continue</Button>
            </div>
        </div>
    </Form>
}